import { render, staticRenderFns } from "./AppSpinner.vue?vue&type=template&id=28f1f911&scoped=true"
var script = {}
import style0 from "./AppSpinner.vue?vue&type=style&index=0&id=28f1f911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1f911",
  null
  
)

export default component.exports